import { render, staticRenderFns } from "./AssignPerson.vue?vue&type=template&id=7d51db61&"
import script from "./AssignPerson.vue?vue&type=script&lang=js&"
export * from "./AssignPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports